// src/components/FooterAttribute.js
import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #f8f8f8; /* Off-white background */
  padding: 1rem;
  text-align: center;
  border-top: 1px solid #ddd;
`;

const FooterText = styled.p`
  color: #333;
  margin: 0;
  font-size: 0.875rem;
  
  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const FooterAttribute = () => {
  return (
    <FooterContainer>
      <FooterText>
        &copy; {new Date().getFullYear()} 1 Digit Technology. All rights reserved.
      </FooterText>
    </FooterContainer>
  );
};

export default FooterAttribute;
